export default __webpack_public_path__ + "static/fb-editorial-balance-e8a06d3162236004664808668e72239e.jpg";